var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIn = function SvgIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF0851",
    d: "M6.941 5a2 2 0 1 1-4-.002 2 2 0 0 1 4 .002m.06 3.48h-4V21h4zm6.32 0h-3.98V21h3.94v-6.57c0-3.66 4.77-4 4.77 0V21h3.95v-7.93c0-6.17-7.06-5.94-8.72-2.91z"
  })));
};
export default SvgIn;